export const environment = {
  production: false,
  api_url: 'https://test.effektivnost.mossport.ru'
};
